import { render } from "./ForgePageButton.vue?vue&type=template&id=2f126d0f&scoped=true&ts=true"
import script from "./ForgePageButton.vue?vue&type=script&lang=ts"
export * from "./ForgePageButton.vue?vue&type=script&lang=ts"

import "./ForgePageButton.vue?vue&type=style&index=0&id=2f126d0f&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f126d0f"]])

export default __exports__